const FUNDING_HIGHLIGHT_SLUGS = new Set( [ 'any', 'ongoing', 'closing_soon', 'new', 'popular', 'saved' ] );

// Resolves the current funding highlight slug from URL query params.
function fundingHighlightSlugFromUrl() {
	const raw = new URLSearchParams( window.location.search ).get( 'funding_highlight' );
	if ( ! raw ) {
		return 'closing_soon';
	}
	const key = raw.replace( /\+/g, ' ' ).trim();
	return FUNDING_HIGHLIGHT_SLUGS.has( key ) ? key : 'closing_soon';
}

// Syncs the visual checked state for funding highlight top tabs.
function syncFundingHighlightTabChecked() {
	const container = document.querySelector( '.funding-listing-highlight-tabs' );
	if ( ! container ) {
		return;
	}

	const current = fundingHighlightSlugFromUrl();

	container.querySelectorAll( 'a.facetwp-radio' ).forEach( ( a ) => {
		if ( ! a.hasAttribute( 'data-value' ) ) {
			return;
		}
		const slug = a.getAttribute( 'data-value' ) ?? '';
		a.classList.toggle( 'checked', slug === current );
	} );
}

// Rebuilds funding tab hrefs with only funding_highlight to clear sidebar facets.
export function syncFundingHighlightTabHrefs() {
	const container = document.querySelector( '.funding-listing-highlight-tabs' );
	if ( ! container ) {
		return;
	}

	const baseUrl = `${ window.location.origin }${ window.location.pathname }`;
	const hash = window.location.hash || '';
	container.querySelectorAll( 'a.facetwp-radio' ).forEach( ( a ) => {
		if ( ! a.hasAttribute( 'data-value' ) ) {
			return;
		}
		const slug = a.getAttribute( 'data-value' ) ?? '';
		const p = new URLSearchParams();
		p.set( 'funding_highlight', slug );

		// "Browse all" also preselects the Funding Status sidebar facet to Open (closed = 0).
		if ( 'any' === slug ) {
			p.set( '_funding_status', '0' );
		}

		const qs = p.toString();
		const path = qs ? `${ baseUrl }?${ qs }` : baseUrl;
		a.setAttribute( 'href', path + hash );
	} );

	syncFundingHighlightTabChecked();
}

// Removes funding_highlight from the current browser URL without reload.
function stripFundingHighlightFromUrl() {
	const u = new URL( window.location.href );
	if ( ! u.searchParams.has( 'funding_highlight' ) ) {
		return;
	}
	u.searchParams.delete( 'funding_highlight' );
	const next = u.pathname + u.search + u.hash;
	window.history.replaceState( null, '', next );
}

// Wires "Clear all filters" to also remove funding_highlight from URL.
export function initFundingListingResetClearsHighlight() {
	const block = document.querySelector( '.funding-listing-block' );
	if ( ! block ) {
		return;
	}

	block.addEventListener(
		'click',
		( e ) => {
			if ( ! e.target.closest( '.facetwp-reset' ) ) {
				return;
			}
			stripFundingHighlightFromUrl();
			syncFundingHighlightTabHrefs();
		},
		true
	);
}

// Note: pagination scroll-to-top is handled globally by FacetWP's own
// "Scroll target" mechanism on the shared "pagination" facet (see
// inc/facetwp.php), not by per-block JS.

// Initializes funding highlight tab href sync on load and FacetWP updates.
export function initFundingHighlightTabHrefs() {
	syncFundingHighlightTabHrefs();
	document.addEventListener( 'facetwp-loaded', syncFundingHighlightTabHrefs );
}

const FUNDING_SIDEBAR_FACETS = [
	'funding_funder',
	'funding_source',
	'funding_type',
	'funding_range',
	'funding_regions',
	'funding_topics',
];

// Normalizes different facet value shapes and checks if they are active.
function facetValueIsActive( value ) {
	if ( Array.isArray( value ) ) {
		return value.some( ( item ) => {
			if ( typeof item !== 'string' ) {
				return Boolean( item );
			}
			const normalized = item.trim().toLowerCase();
			return normalized !== '' && normalized !== 'any';
		} );
	}

	if ( typeof value === 'string' ) {
		const normalized = value.trim().toLowerCase();
		return normalized !== '' && normalized !== 'any';
	}

	if ( value && typeof value === 'object' ) {
		return Object.values( value ).some( ( entry ) => facetValueIsActive( entry ) );
	}

	return Boolean( value );
}

// Adds/removes highlight class on each funding sidebar facet independently.
function syncFundingSidebarHighlight() {
	const wrapper = document.querySelector( '.funding-listing-block .wrapper-categories-sidebar' );
	if ( ! wrapper || ! window.FWP?.facets ) {
		return;
	}

	FUNDING_SIDEBAR_FACETS.forEach( ( facetName ) => {
		const facetEl = wrapper.querySelector( `.facetwp-facet-${ facetName }` );
		if ( ! facetEl ) {
			return;
		}

		const isActive = facetValueIsActive( window.FWP.facets[ facetName ] );
		facetEl.classList.toggle( 'has-active-filter', isActive );
	} );
}

// Initializes sidebar facet highlight sync on load and FacetWP updates.
export function initFundingSidebarActiveFiltersHighlight() {
	syncFundingSidebarHighlight();
	document.addEventListener( 'facetwp-loaded', syncFundingSidebarHighlight );
}
